import { QueryStatus } from "../Response/CustomerResponse";
export interface IDashboardFilterRequest {
  period?: "Today" | "Weekly" | "Monthly" | "Custom";
  startDate?: string;
  endDate?: string;
  customerId?: number;
  transactionType?: number;
  source?: string;
}
export interface AdminLoginRequest {
  email: string;
  password: string;
  clientType: string;
  webName: string;
  deviceId: string;
}

export interface Section {
  id: number;
  sectionName: string;
  displayOrder: number;
  isVisible: boolean;
  platform: number;
  configJson: string;
}

export interface IUIConfigRequest {
  screenName: string;
  sections: Section[];
}

export interface GetUiOrderRequest {
  screenName: string;
  clientType: number;
}

///////// SERVICE TYPES  /////

export interface ICreateServiceRequest {
  id?: number;
  name: string;
  description: string;
  logoUrl: string;
  isActive?: boolean;
  capacity?: number;
  serviceType: string;
}

////// PACKAGE TYPES /////

export interface IServicePackageRequest {
  id?: number;
  serviceId: number;
  packageTitle: string;
  packageSubtitle: string;
  description: string;
  durationMinutes: number;
  bufferMinutes: number;
  capacity?: number;
  validForMonths: number;
  validFor: string[];
  includes: string[];
  pricing: IPackagePricing[];
  isActive?: boolean;
}

export interface IPackagePricing {
  petType: string;
  petSize: string;
  label: string;
  originalPrice: number;
  salePrice: number;
}

///////// SAVE WORKING DAY //////

export interface IServiceWorkingDaysRequest {
  serviceId: number;
  workingDays: IWorkingDay[];
}

export interface IWorkingDay {
  dayOfWeek: number;
  isEnabled: boolean;
  startTime: string;
  endTime: string;
}

///////// BOOKINGS  FILTER //////

export interface IBookingFilterRequest {
  serviceId?: number;
  startDate?: string;
  endDate?: string;
  status?: string;
  petType?: string;
  search?: string;
}

export interface IUpdateBookingStatusRequest {
  bookingId: number;
  status: number;
  paymentStatus: string;
  paymentMethod: string;
  remarks: string;
  notifyCustomer: boolean;
}

//////////  service offer //////

export enum OfferType {
  Percentage = 1,
  Flat = 2,
}

export interface ICreateServiceOfferRequest {
  serviceId: number;
  servicePackageId?: number | null;
  offerType: OfferType;
  offerValue: number;
  offerTitle: string;
  description: string;
  startDate: string;
  endDate: string;
}

///////////    PETS ////////////////

export enum PetSellType {
  Sell = 1,
  Adopt = 2,
}

export enum PetStatus {
  Available = 1,
  Reserved = 2,
  Sold = 3,
  Adopted = 4,
}

export interface ICreatePetRequest {
  id?: number;
  microchipId: string;
  category: string;
  petName: string;
  breed: string;
  price: number;
  salePrice: number;
  bookPrice: number;
  productImage: string;
  description: string;
  age: string;
  gender: string;
  tag: string;
  petType: PetSellType;
  petStatus: PetStatus;
  color: string;
  size: string;
  weight: number;
  isVaccinated: boolean;
  vaccinationDetails: string;
  isKCIRegistered: boolean;
  isFeatured: boolean;
  subImages: string[];
  videos: IPetVideo[];
}

export interface IPetVideo {
  videoUrl: string;
  thumbnailUrl: string;
}

export interface IPetFilterRequest {
  category?: string;
  breed?: string;
  gender?: string;
  petType?: PetSellType;
  minPrice?: number;
  maxPrice?: number;
  isFeatured?: boolean;
  search?: string;
}

export interface IUpdatePetStatusRequest {
  petId: number;
  petStatus: number;
  isFeatured: boolean;
  isActive: boolean;
}

export interface IAddSubcategoryRequest {
  name: string;
  parentId: number;
  imageUrl: string;
  isActive?: true;
}

export interface IUpdateCategoryRequest {
  name: string;
  imageUrl: string;
  isActive?: boolean;
}

export interface IInventoryUploadRequest {
  file: File;
}

export interface IUploadFileRequest {
  File: File;
  FolderName: string;
}

export interface ICreateAddOnRequest {
  servicePackageId: number;
  name: string;
  description: string;
  imageUrl: string;
  price: number;
  isActive: boolean;
  sortOrder: number;
}

export interface IUpdateAddOnStatusRequest {
  id: number;
  isActive: boolean;
}

export interface IUpdateAddOnOrderStatusRequest {
  id: number;
  sortOrder: number;
}

export interface IUpdateAddOnRequest {
  id: number;
  name: string;
  description: string;
  imageUrl: string;
  price: number;
  isActive: boolean;
  sortOrder: number;
}
export interface ICreateBookingRequest {
  userId?: number;

  serviceId: number;

  servicePackageId: number;

  servicePackagePricingId: number;

  petProfileId?: number;

  bookingDate: string;

  startTime: string;

  EndTime?: string;

  paymentMethod: number;

  paymentStatus: number;

  petName?: string;

  petType?: string;

  petBreed?: string;

  petSize?: string;

  notes?: string;

  serviceDataJson?: string;
}

export interface IAdminCreateCustomerRequest {
  fullName: string;
  phoneNumber: string;
  email: string;
}

export interface ICreateEmployeeRequest {
  employeeId?: number;
  serviceId: number;
  name: string;
  phoneNumber: string;
  email: string;
  imageUrl: string;
  isActive?: boolean;
}

export interface IRescheduleBookingRequest {
  bookingId: number;
  bookingDate: string;
  startTime: string;
  remarks: string;
}

export interface IUpdateBookingDurationRequest {
  bookingId: number;
  newEndTime: string;
  remarks: string;
}

export interface IGetBookingsForMonthOrWeekRequest {
  serviceId: number;
  fromDate?: string;
  toDate?: string;
  status?:
    | "Pending"
    | "Confirmed"
    | "InProgress"
    | "Completed"
    | "Cancelled"
    | "Rescheduled";
  paymentStatus?:
    | "Pending"
    | "Paid"
    | "Failed"
    | "Refunded"
    | "PartiallyRefunded"
    | "Expired";
  customerName?: string;
  employeeName?: string;
  search?: string;
}

export interface IGetBookingHistoryRequest {
  serviceId: number;
  bookingId?: number;
  status?:
    | "Pending"
    | "Confirmed"
    | "InProgress"
    | "Completed"
    | "Cancelled"
    | "Rescheduled";
  customerName?: string;
  bookingNumber?: string;
  fromDate?: string;
  toDate?: string;
  pageNumber?: number;
  pageSize?: number;
}
export interface IAssignEmployeeRequest {
  bookingId: number;
  employeeId: number;
  employeeName: string;
}

export interface ICalculatePetTaxiPriceRequest {
  pickupLatitude: number;
  pickupLongitude: number;
  dropLatitude: number;
  dropLongitude: number;
}

export interface IGetBookingDashboard {
  serviceId: number;
  fromDate: string;
  toDate: string;
}

//////////////

export interface IBatchHistoryRequest {
  batchId: string;
  PageNumber?: number;
  PageSize?: number;
  Status?: number;
  ProcessingStatus?: number;
  FromDate?: string;
  ToDate?: string;
}

////// BRANDS REQUEST ////

export interface ICreateBrandRequest {
  name: string;
  description: string;
  logoUrl: string;
}

export interface IChangeBrandStatusRequest {
  isActive: boolean;
}

export interface ICreateCarrierRequest {
  jobTitle: string;
  department: string;
  location: string;
  employmentType: number;
  experienceLevel: number;
  salaryRange: string;
  vacancyCount: number;
  description: string;
  responsibilities: string;
  requirements: string;
  benefits: string;
  lastApplyDate: string;
  isActive: boolean;
  isFeatured: boolean;
}

export interface IUpdateCarrierRequest {
  id: number;
  jobTitle: string;
  department: string;
  location: string;
  employmentType: number;
  experienceLevel: number;
  salaryRange: string;
  vacancyCount: number;
  description: string;
  responsibilities: string;
  requirements: string;
  benefits: string;
  lastApplyDate: string;
  isActive: boolean;
  isFeatured: boolean;
}

export interface IUpdateJobStatus {
  id: number;
  isActive: boolean;
}
export interface IUpdateJobFeatured {
  id: number;
  isFeatured: boolean;
}
export interface IUpdateJobApplicationStatus {
  id: number;
  status: number;
}

//////////////////////////    BLOG ////////////////////////////

export interface ICreateBlogRequest {
  id?: number;
  title: string;
  slug: string;
  shortDescription: string;
  description: string;
  thumbnailUrl: string;
  bannerImageUrl: string;
  authorName: string;
  metaTitle: string;
  metaDescription: string;
  isFeatured: boolean;
  isPublished: boolean;
  publishedAt: string; // ISO Date string
}

export interface IUpdateBlogStatusRequest {
  id: number;
  isPublished: Boolean;
}

//////////////// BANNER /////

export interface IBannerTarget {
  targetType: number;
  targetId: number;
}

export interface ICreateBannerRequest {
  screenSectionId: number;
  title: string;
  subTitle: string;
  imageUrl: string;
  mobileImageUrl: string;
  displayOrder: number;
  isActive: boolean;
  targetType: number;
  targetId: number | null;
  customUrl: string | null;
  targets: IBannerTarget[];
}

export interface IGetBannersRequest {
  screenId?: number;
  screenSectionId?: number;
  redirectType?: number;
  isActive?: boolean;
  search?: string;
  pageNumber?: number;
  pageSize?: number;
}

export interface IUpdateBannerOrderRequest {
  bannerId: number;
  displayOrder: number;
}

//FAQ

export interface ICreateFAQRequest {
  category: number;
  question: string;
  answer: string;
  sortOrder: number;
  isActive: boolean;
}

export interface IUpdateAQRequest {
  id: number;
  category: number;
  question: string;
  answer: string;
  sortOrder: number;
  isActive: boolean;
}

export interface SortOrder {
  id: number;
  isActive: boolean;
}

export interface GetUpdateSortOrderRequest {
  SortOrder: SortOrder[];
}
//// QUERY //

export interface IUpdateCustomerQueryRequest {
  queryId: number;
  status: QueryStatus;
  adminComment: string;
  adminResponse: string;
}

//page

export interface ICreatePageRequest {
  pageType: number;
  title: string;
  content: string;
  isActive: boolean;
}

export interface IUpdatePageRequest {
  id: number;
  pageType: number;
  title: string;
  content: string;
  isActive: boolean;
}

export interface IUpdatePageStatusRequest {
  id: number;
  isActive: boolean;
}

///// COUPON /////

export interface CreateCouponRequest {
  id?: number;
  code: string;
  discountType: string;
  discountValue: number;
  minOrderAmount: number;
  maximumDiscount: number;
  usageLimit: number;
  expiryDate: string;
  isActive: boolean;
}

export interface IGetCouponsRequest {
  search?: string;
  isActive?: boolean;
  pageNumber: number;
  pageSize: number;
}

/////////////////////        product add request /////

export interface IGetProductsRequest {
  searchText?: string;
  brandId?: number;
  categoryId?: number;
  isPublished?: boolean;
  isActive?: boolean;
  pageNumber?: number;
  pageSize?: number;
}

export interface IAddEditProductSingleRequest {
  productId: number;
  productName: string;
  productCode: string;
  slug: string;
  brandId: number;
  categoryIds: number[];
  shortDescription: string;
  description: string;
  videoUrl: string;
  isActive: boolean;
  isPublished: boolean;
  isPetlandRecommended: Boolean;
  variant: ProductVariant;
  images: ProductImage[];
  features: ProductFeature[];
  specifications: ProductSpecification[];
  attributes: ProductAttribute[];
  seo: ProductSeo;
  subscription: ProductSubscription;
  freeClaim: ProductFreeClaim;
  productFamily: ProductFamily;
}

export interface ProductVariant {
  variantId: number;
  sku: string;
  barcode: string;
  price: number;
  salePrice: number;
  discountPercentage: number;
  saleStartDate: string;
  saleEndDate: string;
  stock: number;
  color: string;
  size: string;
  weight: number;
  weightUnit: string;
  length: number;
  width: number;
  height: number;
}

export interface ProductImage {
  imageId: number;
  imageUrl: string;
  isPrimary: boolean;
  sortOrder: number;
}

export interface ProductFeature {
  featureId: number;
  feature: string;
  sortOrder: number;
}

export interface ProductSpecification {
  specificationId: number;
  section: string;
  specificationKey: string;
  specificationValue: string;
}

export interface ProductAttribute {
  attributeId: number;
  attributeName: string;
  attributeValueIds: number[];
  isFilterable: boolean;
  isVisibleOnProductPage: boolean;
}

export interface ProductSeo {
  seoTitle: string;
  seoDescription: string;
  searchKeywords: string;
}

export interface ProductSubscription {
  isEnabled: boolean;
  firstOrderDiscount: number;
  recurringDiscount: number;
}

export interface ProductFreeClaim {
  isEnabled: boolean;
  cartAmountThreshold: number;
}

export interface ProductFamily {
  hasFamily: boolean;
  rootProductId: number;
  taggedProducts: TaggedProduct[];
}

export interface TaggedProduct {
  productId: number;
  sortOrder: number;
}

//AdminOrdersDashboard

export interface IAdminOrderListItem {
  orderId: number;
  orderNumber: string;
  customerName: string;
  totalAmount: number;
  orderStatus: string;
  paymentStatus: string;
  createdOn: string;
}

export interface IAdminOrdersResponse {
  page: number;
  pageSize: number;
  totalRecords: number;
  data: IAdminOrderListItem[];
}

export interface IAdminOrdersRequest {
  page: number;
  pageSize: number;
  search?: string;
  orderStatus?: string;
  period?:string;
  startDate?:string;
  endDate?:string
  isFromAbandonedCart?:boolean
}

//AdminOrderDetails

export interface IAdminOrderDetailsResponse {
  orderId: number;
  orderNumber: string;
  customerName: string;
  customerPhone: string;
  customerEmail: string | null;
  orderStatus: string;
  paymentStatus: string;
  subTotal: number;
  shippingAmount: number;
  taxAmount: number;
  discountAmount: number;
  totalAmount: number;
  createdOn: string;
  address: IAdminOrderAddress;
  items: IAdminOrderItem[];
  statusHistories: IAdminOrderStatusHistory[];
}

export interface IAdminOrderAddress {
  fullName: string;
  phoneNumber: string;
  addressLine1: string;
  addressLine2: string;
  city: string;
  state: string;
  country: string;
  postalCode: string;
}

export interface IAdminOrderItem {
  productVariantId: number;
  productName: string;
  variantName: string;
  quantity: number;
  unitPrice: number;
  unitSalePrice: number;
  totalPrice: number;
  isPromotional: boolean;
  isFreeItem: boolean;
}

export interface IAdminOrderStatusHistory {
  status: string;
  notes: string;
  createdOn: string;
}

////////////////////// BUNDLES ////////

export interface ICreateBundleRequest {
  name: string;
  description: string;
  imageUrl: string;
  price: number;
  items: BundleItem[];
}

export interface BundleItem {
  productId: number;
  quantity: number;
}

export interface IChangeBundleStatusRequest {
  isActive: Boolean;
}

////////    ATTRIBUTE ///

export interface IGetAttributeRequest {
  search?: string;
  isActive?: boolean;
  pageNumber?: number;
  pageSize?: number;
}

////// ADMIN ORDER REVIEW ////

export interface IOrderReviewActionRequest {
  orderId: number;
  action: number;
  adminRemarks?: string;
  items?: IOrderRevisionItemRequest[];
}

export interface IOrderRevisionItemRequest {
  sequenceNo: number;

  action: string;

  targetType: string;

  orderItemId?: number;

  productVariantId?: number;

  quantity?: number;

  unitSalePrice?: number;

  reason?: string;
}

////// ORDER SUBMIT REVIEW ???

export interface ISubmitReviewOrderRequest {
  orderId: number;
  action: "Approve" | "Reject" | "RequestRevision" | string;
  adminRemarks: string;
  revisedItems: IRevisedItem[];
  pets: IReviewPet[];
  services: IReviewService[];
  updateOrderStatus: boolean;
  newOrderStatus: string;
}

export interface IRevisedItem {
  orderItemId: number;
  remainingQuantity: number;
  unitSalePrice: number;
  replacements: IReplacementItem[];
  reason: string;
}

export interface IReplacementItem {
  productId: number;
  productVariantId: number;
  quantity: number;
  unitSalePrice: number;
}

export interface IReviewPet {
  orderPetItemId: number;
  remove: boolean;
  reason: string;
}

export interface IReviewService {
  orderServiceItemId: number;
  remove: boolean;
  unitSalePrice: number;
  reason: string;
}

export interface IOrderFullFIllRequest {
  status:
    | "Packed"
    | "Shipped"
    | "Delivered"
    | "Cancelled"
    | "Return"
    | "Refund";
  provider: string;
  vehicleType: "bike" | "car";
  courierName: string;
  trackingNumber: string;
  remarks: string;
  statusDate: string;
}

export interface IAdminRefundRequest {
  amount: number;
  refundMethod: "Wallet" | "OriginalPayment";
  reason: string;
  confirmWarnings?: boolean;
}

export interface IAdminRefundResponse {
  success: boolean;
  requiresConfirmation?: boolean;
  warnings?: string[];
  message?: string;
}
////  SUBACRIPTION ///

// export interface ISubscriptionFilterParams {
//   search?: string;
//   status?: 1 | 2 | 3 | 4 | 5;
//   billingCycle?: 1 | 2 | 3;
//   autoRenew?: boolean;
//   fromDate?: string;
//   toDate?: string;
//   productId?: number;
//   productVariantId?: number;
//   pageNumber?: number;
//   pageSize?: number;
// }
/// Return
export interface ICreateReturnRequest {
  reason: string;
  adminRemarks: string;
  items: IReturnItem[];
}

export interface IReturnItem {
  orderItemId: number;
  quantity: number;
  reason: string;
}
//// sub ///

export interface ISubscriptionFilterParams {
  search?: string;
  status?: 1 | 2 | 3 | 4 | 5;
  billingCycle?: 1 | 2 | 3;
  autoRenew?: boolean;
  fromDate?: string;
  toDate?: string;
  sortBy?: "newest" | "oldest"; // Added sorting param
  productId?: number;
  productVariantId?: number;
  pageNumber?: number;
  pageSize?: number;
}

//////    ABANDONED CART /////

export interface ICustomerListRequest {
  page?: number;
  pageSize?: number;
  search?: string;
  isActive?: boolean | null;
}

export interface ICreditUserWalletRequest {
  userId: number;
  amount: number;
  remarks: string;
}

export interface ICreditUserRewardRequest {
  userId: number;
  points: number;
  remarks: string;
}

export type TransactionType =
  | "Credit"
  | "Debit"
  | "Refund"
  | "TopUp"
  | "AdminAdjustment"
  | "Cashback"
  | "Bonus";

export type ReferenceType =
  | "Order"
  | "TopUp"
  | "Refund"
  | "AdminAdjustment"
  | "Cashback"
  | "Promotion";

export type TransactionStatus =
  | "Pending"
  | "Completed"
  | "Failed"
  | "Cancelled";

export interface IWalletTransactionListRequest {
  page?: number;
  pageSize?: number;
  userId?: number;
  search?: string;
  transactionType?: TransactionType | null;
  referenceType?: ReferenceType | null;
  fromDate?: string | null; // ISO DateTime
  toDate?: string | null; // ISO DateTime
  status?: TransactionStatus | null;
}
export type RewardTransactionType =
  | "Earn"
  | "Redeem"
  | "Refund"
  | "Expired"
  | "AdminAdjustment"
  | "PromotionalBonus";

export type RewardTransactionStatus =
  | "Pending"
  | "Completed"
  | "Cancelled"
  | "Failed";

export interface IRewardTransactionListRequest {
  page?: number;
  pageSize?: number;
  userId?: number;
  search?: string;
  transactionType?: RewardTransactionType | null;
  status?: RewardTransactionStatus | null;
  fromDate?: string | null; // ISO DateTime
  toDate?: string | null; // ISO DateTime
}

export type CartType = "Product" | "Pet" | "Service";

export interface IAbandonedCartListRequest {
  search?: string;
  cartType?: CartType | null;
  fromDate?: string | null; // ISO DateTime
  toDate?: string | null; // ISO DateTime
  pageNumber?: number;
  pageSize?: number;
}

export interface ISendBulkReminderRequest {
  sendToAll: boolean;
  userIds: number[];
}

export interface IPersonetRequest {
  customerId: number;
}

export interface ICustomerAddressRequest {
  fullName: string;
  phoneNumber: string;
  addressLine1: string;
  addressLine2: string;
  city: string;
  state: string;
  country: string;
  postalCode: string;
  latitude: number;
  longitude: number;
  addressType: "Home" | "Work" | "Other";
  isDefault: boolean;
  isActive: boolean;
}

export interface ICustomerPetRequest {
  petName: string;
  petType: "Dog" | "Cat" | string;
  breed: string;
  gender: "Male" | "Female" | string;
  weight: number;
  dateType: string;
  petDate: string;
  furColor: string;
  activityLevel: string;
  personality: string;
  foodPreferences: string;
  dietFrequency: string;
  portionSize: string;
  favouriteTreats: string;
  noKnownIssues: boolean;
  healthConditions: string;
  requiresVetConsultationAlert: boolean;
  groomingFrequency: string;
  sheddingFrequency: string;
  breedSize: string;
  photoUrl: string;
  isActive: boolean;
}

/// SETTINGS ///

export interface IAdminSettingRequest {
  value: string;
}

export interface IApplicationSetting {
  key: string;
  displayName: string;
  description: string;
  value: string;
  defaultValue?: string;
  minValue?: string;
  maxValue?: string;
  dataType: string;
  isEditable: boolean;
  isDisplay: boolean;
  updatedOn?: string;
  updatedBy?: string;
  allowedValues?: string;
}

export interface IApplicationSettingGroup {
  group: string;
  displayName: string;
  icon: string;
  settings: IApplicationSetting[];
}

export interface IApplicationSettingsResponse {
  groups: IApplicationSettingGroup[];
}
//--------------------------------------------------
// Update Multiple Settings
//--------------------------------------------------

export interface IUpdateApplicationSettingsRequest {
  settings: IUpdateApplicationSettingRequest[];
}

export interface IUpdateApplicationSettingRequest {
  key: string;
  value: string;
}

export interface IEmailTemplate {
  id: number;
  name: string;
  templateKey: string;

  emailCategoryId: number;
  emailLayoutId: number;

  subject: string;
  htmlBody: string;
  plainTextBody?: string | null;
  description?: string | null;

  isSystem: boolean;
  isActive: boolean;
  version: number;

  createdOn?: string;
  modifiedOn?: string | null;
}

export interface ICreateEmailTemplateRequest {
  name: string;
  templateKey: string;
  subject: string;
  emailCategoryId: number;
  emailLayoutId: number;
  htmlBody: string;
  plainTextBody: string;
  description: string;
  isActive: boolean;
}

export interface IPreviewEmailTemplateRequest {
  templateKey: string;
  variables: Record<string, string>;
}

export interface IEmailTemplateLookupItem {
  id: number;
  name: string;
}

//--------------------------------------------------
// EMAIL BRANDING PROFILES
// --------------------------------------------------

export interface IEmailBrandingProfile {
  id: number;

  name: string;
  companyName: string;
  tagLine: string;

  logoUrl: string;

  primaryColor: string;
  secondaryColor: string;

  websiteUrl: string;

  supportEmail: string;
  supportPhone: string;

  address: string;

  facebookUrl?: string | null;
  instagramUrl?: string | null;
  twitterUrl?: string | null;
  linkedInUrl?: string | null;
  youTubeUrl?: string | null;

  copyrightText: string;

  termsUrl: string;
  privacyPolicyUrl: string;

  isDefault: boolean;
  isActive: boolean;

  createdOn?: string;
  modifiedOn?: string | null;
}

export interface ICreateEmailBrandingProfileRequest {
  name: string;
  companyName: string;
  tagLine: string;

  logoUrl: string;

  primaryColor: string;
  secondaryColor: string;

  websiteUrl: string;

  supportEmail: string;
  supportPhone: string;

  address: string;

  facebookUrl?: string | null;
  instagramUrl?: string | null;
  twitterUrl?: string | null;
  linkedInUrl?: string | null;
  youTubeUrl?: string | null;

  copyrightText: string;

  termsUrl: string;
  privacyPolicyUrl: string;

  isActive: boolean;
}

export interface IUpdateEmailBrandingProfileRequest {
  name: string;
  companyName: string;
  tagLine: string;

  logoUrl: string;

  primaryColor: string;
  secondaryColor: string;

  websiteUrl: string;

  supportEmail: string;
  supportPhone: string;

  address: string;

  facebookUrl?: string | null;
  instagramUrl?: string | null;
  twitterUrl?: string | null;
  linkedInUrl?: string | null;
  youTubeUrl?: string | null;

  copyrightText: string;

  termsUrl: string;
  privacyPolicyUrl: string;

  isActive: boolean;
}

// --------------------------------------------------
// EMAIL LAYOUTS
// --------------------------------------------------

export interface IEmailLayout {
  id: number;

  name: string;
  description: string;

  headerHtml: string;
  footerHtml: string;

  brandingProfileId: number;
  brandingProfileName: string;

  isDefault: boolean;
  isActive: boolean;
}

export interface ICreateEmailLayoutRequest {
  name: string;
  description: string;

  headerHtml: string;
  footerHtml: string;

  brandingProfileId: number;

  isDefault: boolean;
  isActive: boolean;
}

export interface IUpdateEmailLayoutRequest {
  name: string;
  description: string;

  headerHtml: string;
  footerHtml: string;

  brandingProfileId: number;

  isActive: boolean;
}

// --------------------------------------------------
// EMAIL CATEGORIES
// --------------------------------------------------

export interface IEmailCategory {
  id: number;

  name: string;
  displayName: string;
  description: string;

  sortOrder: number;

  isSystem: boolean;
  isActive: boolean;

  templateCount?: number;
}

export interface ICreateEmailCategoryRequest {
  name: string;
  displayName: string;
  description: string;
  sortOrder: number;
  isActive: boolean;
}

export interface IUpdateEmailCategoryRequest {
  displayName: string;
  description: string;
  sortOrder: number;
  isActive: boolean;
}

//////////////////////  SCREENS  ///////

export interface ICreateHomepageSectionRequest {
  sectionType: string;

  contentType: ContentType;

  sectionName: string;

  displayName: string;

  description: string;

  layoutType: string | null;

  maxItems: number;

  allowMultiple: boolean;

  recommendedWidth: number;

  recommendedHeight: number;

  aspectRatio: string | null;

  mobileRecommendedWidth: number;

  mobileRecommendedHeight: number;

  mobileAspectRatio: string | null;

  isVisible: boolean;

  clientType: string;

  ConfigJson: string | null;
}
export interface ICreateHomepageSectionItemsRequest {
  items: IHomepageSectionItemRequest[];
}

export interface IHomepageSectionItemRequest {
  id?: number | null;
  itemType: ContentType;
  itemId: number | null;
  displayOrder: number;
  isActive: boolean;

  title?: string | null;
  imageUrl?: string | null;
  redirectUrl?: string | null;
  configJson?: string | null;
}

export interface ISectionIdsRequest {
  sectionIds: number[];
}

//////////////////////  SCREENS  ///////

export type ContentType =
  | "Product"
  | "Category"
  | "Brand"
  | "Pet"
  | "Service"
  | "Video"
  | "Custom";

export interface ICreateHomepageSectionRequest {
  sectionType: string;

  contentType: ContentType;

  sectionName: string;

  displayName: string;

  description: string;

  layoutType: string | null;

  maxItems: number;

  allowMultiple: boolean;

  recommendedWidth: number;

  recommendedHeight: number;

  aspectRatio: string | null;

  mobileRecommendedWidth: number;

  mobileRecommendedHeight: number;

  mobileAspectRatio: string | null;

  isVisible: boolean;

  clientType: string;

  ConfigJson: string | null;
}
export interface ICreateHomepageSectionItemsRequest {
  items: IHomepageSectionItemRequest[];
}

export interface IHomepageSectionItemRequest {
  id?: number | null;
  itemType: ContentType;
  itemId: number | null;
  displayOrder: number;
  isActive: boolean;

  title?: string | null;
  imageUrl?: string | null;
  redirectUrl?: string | null;
  configJson?: string | null;
}

export interface ISectionIdsRequest {
  sectionIds: number[];
}

export interface IUpdateSubBillingCycleAdminRequest {
  billingCycle: string;
  interval: number;
}

export interface IAnalyticsDashboardSummary {
  totalEvents: number;
  bannerViews: number;
  bannerClicks: number;
  productViews: number;
  searches: number;
  uniqueUsers: number;
  uniqueSessions: number;
  bannerClickThroughRate: number;
}

export interface IAnalyticsTrend {
  date: string;
  bannerViews: number;
  bannerClicks: number;
  productViews: number;
  searches: number;
}

export interface IAnalyticsEntity {
  entityId: number;
  views: number;
  clicks: number;
  clickThroughRate: number;
}

export interface IAnalyticsSearch {
  searchTerm: string;
  searchCount: number;
}

export interface IAnalyticsDashboardData {
  summary: IAnalyticsDashboardSummary;
  trend: IAnalyticsTrend[];
  topBanners: IAnalyticsEntity[];
  topProducts: IAnalyticsEntity[];
  topSearches: IAnalyticsSearch[];
}

export interface IAnalyticsDashboardResponse {
  success: boolean;
  message: string;
  data: IAnalyticsDashboardData;
}

export interface IAnalyticsDashboardSummary {
  totalEvents: number;
  bannerViews: number;
  bannerClicks: number;
  productViews: number;
  searches: number;
  uniqueUsers: number;
  uniqueSessions: number;
  bannerClickThroughRate: number;
}

export interface IAnalyticsTrend {
  date: string;
  bannerViews: number;
  bannerClicks: number;
  productViews: number;
  searches: number;
}

export interface IAnalyticsEntity {
  entityId: number;
  views: number;
  clicks: number;
  clickThroughRate: number;
}

export interface IAnalyticsSearch {
  searchTerm: string;
  searchCount: number;
}

export interface IAnalyticsDashboardData {
  summary: IAnalyticsDashboardSummary;
  trend: IAnalyticsTrend[];
  topBanners: IAnalyticsEntity[];
  topProducts: IAnalyticsEntity[];
  topSearches: IAnalyticsSearch[];
}

export interface IAnalyticsDashboardResponse {
  success: boolean;
  message: string;
  data: IAnalyticsDashboardData;
}


export interface IAbandonedCartRequest {
    abandonedCartId: number,
  comment: string
}

/// admin Section///


export interface IUpdateSectionStatusRequest{
  isActive: boolean
}

export interface IAbandonedCartRequest {
    abandonedCartId: number,
  comment: string
}

/// admin Section///


export interface IUpdateSectionStatusRequest{
  isActive: boolean
}

export interface IUpdatePetsRemainingPaymentRequest{
  orderId: number,
  petId?: number,
  comment: string

}